import React from 'react';
import { motion } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { GraduationCap, Building2, Monitor, Trophy, Users, BookOpen } from 'lucide-react';
const highlights = [{
  icon: GraduationCap,
  title: 'Academic Excellence',
  description: 'Consistently high pass rates and outstanding results in national examinations'
}, {
  icon: Building2,
  title: 'Modern Campus',
  description: 'State-of-the-art facilities with spacious classrooms and advanced infrastructure'
}, {
  icon: Monitor,
  title: 'Digital Learning',
  description: 'Smart classrooms and technology-integrated curriculum for 21st century education'
}, {
  icon: Trophy,
  title: 'Extra-curricular Activities',
  description: 'Comprehensive programs in sports, arts, debate, and cultural activities'
}, {
  icon: Users,
  title: 'Experienced Faculty',
  description: 'Dedicated team of qualified teachers committed to student success'
}, {
  icon: BookOpen,
  title: 'Islamic Values',
  description: 'Education rooted in faith, morality, and ethical principles'
}];
export function KeyHighlights() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section id="academic" className="pt-20 pb-10 bg-white" data-id="element-164">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <div className="text-center mb-16" data-id="element-166">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-text-dark mb-4" data-id="element-167">
            Why Choose MDIC
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto mb-4" data-id="element-168"></div>
          <p className="text-lg text-text-muted max-w-2xl mx-auto" data-id="element-169">
            Discover what makes us one of the leading educational institutions
            in Bangladesh
          </p>
        </div>

        <div ref={ref} className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-170">
          {highlights.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={item.title} initial={{
            opacity: 0,
            y: 30
          }} animate={isVisible ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-white border border-gray-200 rounded-lg p-6 shadow-md hover:shadow-lg hover:-translate-y-1 transition-all" data-id="element-171">
                <div className="bg-primary/10 w-14 h-14 rounded-lg flex items-center justify-center mb-4" data-id="element-172">
                  <Icon className="text-primary" size={28} data-id="element-173" />
                </div>
                <h3 className="text-xl font-heading font-semibold text-text-dark mb-3" data-id="element-174">
                  {item.title}
                </h3>
                <p className="text-text-muted leading-relaxed" data-id="element-175">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}